<div class="document-container">
    <cx-spinner *ngIf="loading === GenLoadingEnum.Loading;"></cx-spinner>

    <ng-container *ngIf="documents?.length > 0">
      <div class="document-list-header" *ngIf="!isMobileView">
        <thead>
          <th scope="col" class="file-type">{{ "productList.fileType" | cxTranslate }}</th>
          <th scope="col" class="file-name">{{ "productList.fileName" | cxTranslate }}</th>
          <th scope="col" class="item-number">{{ "productList.itemNumber" | cxTranslate }}</th>
          <th scope="col" class="language">{{ "productList.language" | cxTranslate }}</th>
        </thead>
      </div>
      <div class="cx-product-container">
        <gen-document-list-item *ngFor="let document of documents" [document]="document">
        </gen-document-list-item>
      </div>
      <div class="toggle-button">
        <ng-container *ngIf="pagination?.totalResults > defaultPageSize">
          <button class="toggle" (click)="toggleDocuments()">{{ documents?.length !== pagination?.totalResults ? 'Show More' : 'Show Less' }}</button>
        </ng-container>
      </div>
    </ng-container>
</div>
